/* ============================================================
 * lbf-cart-page.js  v1.0  (2026-09-26, cart journey redesign, build spec 3.4 / 3.6)
 * Cart page only. Needs lbf-cart-journey.js (LBF_CART, LBF_TOAST, LBF_PROMOS) and
 * lbf-shipping-core.js (LBF_SHIPPING: every fee and threshold - nothing re-implemented).
 *   - summary card under "Your cart": in progress first (neutral), then earned (green),
 *     one gold for every bar
 *   - ship-choice card when the frozen minimum is unmet (replaces the two opposite asks)
 *   - "Often ordered together" rail (fill order spec 3.4.7), hidden while the minimum is
 *     unmet or frozen is blocked for Sabah/Sarawak
 *   - collapsed "Order special instructions" -> cart note
 *   - sticky footer: Subtotal (struck SRP) / Shipping [area chip] (struck standard fee) / checkout
 * The old footer, MOQ helper and checkout guard stay in the DOM (hidden) so every existing
 * rule, event and app hook keeps running underneath.
 * ============================================================ */
(function boot() {
  'use strict';
  var lbnT = window.lbnT || function (k, f, v) { return v ? String(f).replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, x) { return Object.prototype.hasOwnProperty.call(v, x) ? String(v[x]) : m; }) : f; };
  /* lbf-cart-journey.js is output near the end of <body>, after this section's script, so wait
     for every deferred script to have run (they all run before DOMContentLoaded). */
  if (!window.LBF_CART || !window.LBF_SHIPPING) {
    /* every deferred script has run by DOMContentLoaded; the short retry is only a safety net */
    if (!boot.w) { boot.w = 1; document.addEventListener('DOMContentLoaded', boot); }
    boot.n = (boot.n || 0) + 1;
    if (boot.n < 100) setTimeout(boot, 40);
    return;
  }
  if (!window.LBF_CART || !window.LBF_SHIPPING || window.__lbfCartPage) return;
  window.__lbfCartPage = true;
  var CART = window.LBF_CART, CORE = window.LBF_SHIPPING, P = window.LBF_PROMOS;
  /* 2026-09-26 cart DRAWER mode (Carl): the same script drives the drawer on every page except /cart */
  var DRAWER_EL = document.getElementById('main-cart-items') ? null : document.querySelector('cart-drawer');
  var DRAWER = !!DRAWER_EL;
  if (!DRAWER && !document.getElementById('main-cart-items')) return;
  function drawerOpen() { return DRAWER_EL && DRAWER_EL.classList.contains('active'); }
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var FROZEN_COLL = 'frozen-family-meals';

  function money(c) { return 'RM' + (Number(c || 0) / 100).toFixed(2); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  /* one helper (GA4 + dataLayer + Shopify.analytics) lives in lbf-cart-journey.js; plain dataLayer push if it is missing */
  function track(event, data) {
    if (window.LBF_CART && typeof window.LBF_CART.track === 'function') return window.LBF_CART.track(event, data);
    try { window.dataLayer = window.dataLayer || []; data = data || {}; data.event = event; window.dataLayer.push(data); } catch (e) {}
  }
  function lower(a) { return (a || []).map(function (x) { return String(x).trim().toLowerCase(); }); }
  function isFrozen(li) { return String(li.product_type || li.type || '').toLowerCase() === 'frozen'; }

  var info = {}; /* handle -> /products/x.js, pre-filled from the HTML (theme.liquid __LBF_CJ) */
  var BOOTDATA = window.__LBF_CJ || {};
  Object.keys(BOOTDATA.products || {}).forEach(function (h) { info[h] = BOOTDATA.products[h]; });
  function productInfo(h) {
    if (info[h]) return Promise.resolve(info[h]);
    return fetch(ROOT + 'products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { if (p) info[h] = p; else retrySoon(); return p || { tags: [], variants: [] }; })
      .catch(function () { retrySoon(); return { tags: [], variants: [] }; }); /* never cache a failure (429 while adding fast) */
  }
  var retryT = 0;
  function retrySoon() { clearTimeout(retryT); retryT = setTimeout(function () { var c = CART.get(); if (c) paint(c); }, 2500); }
  function withInfo(c) {
    var hs = (c.items || []).map(function (li) { return li.handle; }).filter(function (h, i, a) { return a.indexOf(h) === i && !info[h]; });
    return Promise.all(hs.map(productInfo)).then(function () { return c; });
  }
  /* the shape lbf-shipping-core expects (same as the collection bar builds) */
  function coreState(c) {
    return {
      items: (c.items || []).map(function (li) {
        var tags = lower((info[li.handle] || {}).tags);
        var type = String(li.product_type || '').toLowerCase();
        return { handle: li.handle, key: li.key, qty: li.quantity, linePrice: li.final_line_price, variantId: String(li.variant_id),
          frozenType: type === CORE.FROZEN_TYPE || tags.indexOf('frozen') !== -1,
          frozenTag: type === CORE.FROZEN_TYPE || CORE.FROZEN_TAGS.some(function (t) { return tags.indexOf(t) !== -1; }),
          retortType: type === CORE.RETORT_TYPE, soloOk: tags.indexOf(CORE.SOLO_TAG) !== -1, title: li.product_title };
      }),
      totalPrice: c.total_price || 0,
      voucher: CORE.voucherFromCart(c)
    };
  }
  function srpTotal(c) {
    var srp = 0;
    (c.items || []).forEach(function (li) {
      var p = info[li.handle]; var v = p && (p.variants || []).filter(function (x) { return String(x.id) === String(li.variant_id); })[0];
      var original = Number(li.original_line_price != null ? li.original_line_price : li.final_line_price) || 0;
      var cmp = v && v.compare_at_price > v.price ? v.compare_at_price * li.quantity : 0;
      /* Compare the undiscounted baseline with cart.total_price once: it already includes
         Shopify's line and order discounts. RM0 gift products never gain a compare-at value. */
      srp += original > 0 ? Math.max(original, cmp) : 0;
    });
    return srp;
  }
  function chipLabel(state) { return state === 'kl-sel' ? lbnT('ship.chip_kl_sel', 'KL/SEL') : state === 'wm' ? lbnT('ship.chip_other_wm', 'Other WM') : state === 'east-msia' ? lbnT('ship.chip_east_msia', 'East Msia') : lbnT('ship.chip_west_msia', 'West Msia'); }
  function openArea(step) {
    if (!window.LBF_SHIPPING_POPUP) return;
    var c = CART.get(); if (!c) return;
    LBF_SHIPPING_POPUP.open({ cart: coreState(c), step: step || 1, trigger: 'cart-chip', reason: 'manual' });
    /* a blocked cart always opens on the Sabah/Sarawak sheet; CHANGE LOCATION means the area list, so go straight there */
    if ((step || 1) === 1) setTimeout(function () { var b = document.querySelector('.lbfsp.is-open [data-lbfsp-change]'); if (b) b.click(); }, 0);
  }

  /* ---------------- what the cart knows right now ---------------- */
  function model(c) {
    var st = coreState(c);
    var frozenCart = st.items.some(function (i) { return i.frozenTag; });
    var region = CORE.activeRegion(frozenCart) || (frozenCart ? null : 'west-msia');
    var s = CORE.compute(st, region, {});
    var paid = (c.items || []).filter(function (li) { return li.final_line_price > 0; });
    var fzPaid = paid.filter(function (li) { return isFrozen(li) && lower((info[li.handle] || {}).tags).indexOf('cc_solo_ok') === -1; });
    var fzQty = fzPaid.reduce(function (a, li) { return a + li.quantity; }, 0);
    var rte = paid.filter(function (li) { return !isFrozen(li); });
    return { c: c, st: st, s: s, region: region, frozenCart: frozenCart, fzQty: fzQty,
      moqUnmet: s.kind === 'moq', blocked: s.kind === 'blocked',
      rteTotal: rte.reduce(function (a, li) { return a + li.final_line_price; }, 0), hasRte: rte.length > 0,
      srp: srpTotal(c) };
  }

  /* ---------------- 1. summary card ---------------- */
  function summaryRows(m) {
    var s = m.s, rows = [];
    var vn = s.voucherNote, voucherFree = !!(vn && vn.kind === 'free');
    var splitRows = CART.splitDeliveryRows(s);
    if (splitRows) return splitRows;
    if (m.blocked) {
      rows.push({ ok: false, block: true, t: lbnT('cart.sum_blocked_sabah', "We can't ship the frozen dishes in your cart to Sabah / Sarawak.") });
    } else if (m.moqUnmet) {
      var need = CORE.MOQ - m.fzQty;
      rows.push({ ok: false, block: true, t: (need > 1 ? lbnT('cart.sum_moq_other', 'Add {{ n }} more frozen dishes for cold-chain delivery', { n: need }) : lbnT('cart.sum_moq_one', 'Add {{ n }} more frozen dish for cold-chain delivery', { n: need })), count: lbnT('cart.count_of_total', '{{ have }} of {{ total }}', { have: m.fzQty, total: CORE.MOQ }), seg: [m.fzQty, CORE.MOQ] });
    } else if (s.kind === 'pickstate') {
      rows.push({ ok: false, pri: 1, t: lbnT('cart.sum_pick_area', 'Choose your area to see your delivery fee'), act: 'area' });
    } else if (s.kind === 'progress' && !voucherFree) {
      rows.push({ ok: false, pri: 1, t: lbnT('ship.more_for_free_delivery', '{{ amount }} more for FREE delivery', { amount: money(s.remaining) }), pct: s.pct / 100 });
    } else if (s.kind === 'mixed-progress' && !voucherFree) {
      rows.push({ ok: false, pri: 1, t: (CORE.seasonalNudge && CORE.seasonalNudge(s)) || (s.tierFree ? lbnT('ship.add_for_free_delivery', 'Add {{ amount }} for free delivery', { amount: money(s.remaining) }) : lbnT('ship.add_to_save_on_delivery', 'Add {{ amount }} to save {{ saving }} on delivery', { amount: money(s.remaining), saving: money(s.tierSaving).replace('.00', '') })), pct: s.pct / 100 });
    } else if (s.kind === 'free' && !vn) {
      rows.push({ ok: true, rank: 1, t: lbnT('ship.you_enjoy_free_delivery', 'You enjoy free delivery') });
    } else if (s.kind === 'mixed-floor' && !vn) {
      rows.push({ ok: true, rank: 1, t: s.rate === 0 ? lbnT('ship.you_enjoy_free_delivery', 'You enjoy free delivery') : lbnT('ship.you_saved_on_delivery', 'You saved {{ amount }} on delivery', { amount: money(s.baseRate - s.floorRate).replace('.00', '') }) });
    }
    if (vn) rows.push({ ok: true, rank: 1, t: vn.text });
    return rows;
  }
  function renderSummary(m) {
    var box = document.getElementById('lbf-cj-summary');
    if (!box) return;
    /* Carl 2026-09-26: live's blue cold-chain note, at the top, whenever frozen is in the cart */
    var cold = document.getElementById('lbf-cj-cold');
    if (cold) cold.remove(); /* now a row inside the card (Carl) */
    if (!(m.c.items || []).length) { box.hidden = true; return; }
    CART.summaryRows(m.c).catch(function () { retrySoon(); return []; }).then(function (extra) {
      box = document.getElementById('lbf-cj-summary'); if (!box) return;
      /* shared rows = [ready-to-eat delivery, gifts...]; the cart builds its own delivery row from the shipping core */
      var rows = summaryRows(m).concat(extra.filter(function (r) { return !r.delivery && !r.cold; }));
      /* cold chain, unlocked: blue, first among the wins */
      if (m.frozenCart && !m.moqUnmet && !m.blocked) rows.unshift({ ok: true, cold: true, rank: 4,
        t: m.s.splitWarn ? lbnT('cart.sum_two_boxes', 'Your order ships in 2 boxes') : lbnT('cart.sum_cold_chain', 'Ships by cold-chain delivery, packed in insulated packaging'),
        sub: m.s.splitWarn ? lbnT('cart.sum_two_boxes_sub', 'Box 1: Season Exclusive. Box 2: All other dishes.') : '' });
      /* 23 Oct (Carl D3): under the frozen minimum with CNY dishes in the cart, say they ship apart; the row opens the two-box sheet */
      if (m.moqUnmet && m.s.splitWarn && window.LBN_TWO_BOX) rows.splice(1, 0, { ok: true, cold: true, rank: 4, act: 'twobox',
        t: lbnT('cart.sum_two_boxes', 'Your order ships in 2 boxes'), sub: lbnT('ship.tb_line_sub', "CNY dishes ship in their own box and don't count towards the 3 frozen dishes.") });
      if (m.srp && m.srp > m.c.total_price) rows.push({ ok: true, rank: 3, t: lbnT('cart.sum_saved_order', 'You saved {{ amount }} on this order', { amount: money(m.srp - m.c.total_price) }) });
      box.innerHTML = CART.summaryHTML(rows, 1, { cap: 3 }); /* Carl 2026-09-26: top 3 up front */
      box.hidden = false;
      box.classList.remove('is-skel'); box.removeAttribute('aria-busy');
      Array.prototype.forEach.call(box.querySelectorAll('[data-sum-act="area"]'), function (el) { el.addEventListener('click', function () { openArea(1); }); });
      Array.prototype.forEach.call(box.querySelectorAll('[data-sum-act="twobox"]'), function (el) { el.addEventListener('click', function () { window.LBN_TWO_BOX.open('summary'); }); });
    });
  }

  /* ---------------- 1b. Buy 3 Free 1 progress on the dish's own line (Carl decision 1 = A) ---------------- */
  function renderLineDeals(m) {
    var rules = P.rules().filter(function (r) { return r.kind === 'sku'; });
    Array.prototype.forEach.call(document.querySelectorAll('.cart-items .cart-item'), function (row) {
      var old = row.querySelector('.lbf-cj-deal'); if (old) old.remove();
      var inp = row.querySelector('input[data-quantity-variant-id]');
      if (!inp) return;
      var vid = String(inp.getAttribute('data-quantity-variant-id'));
      var li = (m.c.items || []).filter(function (x) { return String(x.variant_id) === vid && x.final_line_price > 0; })[0];
      if (!li) return;
      var tags = lower((info[li.handle] || {}).tags);
      rules.forEach(function (r) {
        if (tags.indexOf(r.tag) === -1) return;
        var have = li.quantity % r.need, rem = r.need - have;
        if (!have) return;
        var det = row.querySelector('.cart-item__details');
        if (det) det.insertAdjacentHTML('beforeend', '<div class="lbf-cj-deal">' + lbnT('cart.line_deal', 'Add {{ n }} more for {{ free }} FREE', { n: rem, free: r.free }) + ' <em>· ' + lbnT('cart.count_of_total', '{{ have }} of {{ total }}', { have: have, total: r.need }) + '</em></div>');
      });
    });
  }

  /* ---------------- 2. group headers ---------------- */
  function renderGroups(m) {
    /* Carl 2026-09-26: FROZEN is FROZEN, READY-TO-EAT is READY-TO-EAT - no sub-copy */
    var fz = document.querySelector('.lbf-cart-sec--frozen .lbf-cart-sec__title');
    if (fz) fz.__lbf = 1;
  }

  /* ---------------- 3. ship-choice card (spec 3.6) ---------------- */
  var frozenPool = null;
  function loadFrozenPool(c) {
    if (frozenPool) return Promise.resolve(frozenPool);
    var ids = (c.items || []).filter(isFrozen).map(function (li) { return li.product_id; }).filter(function (v, i, a) { return a.indexOf(v) === i; }).slice(0, 3);
    return Promise.all(ids.map(function (id) {
      return fetch(ROOT + 'recommendations/products.json?product_id=' + id + '&intent=related&limit=10').then(function (r) { return r.ok ? r.json() : { products: [] }; }).then(function (j) { return j.products || []; }).catch(function () { return []; });
    }).concat([fetch(ROOT + 'collections/' + FROZEN_COLL + '/products.json?limit=30').then(function (r) { return r.ok ? r.json() : { products: [] }; }).then(function (j) { return j.products || []; }).catch(function () { return []; })]))
      .then(function (lists) {
        var seen = {}, out = [];
        lists.forEach(function (l) { l.forEach(function (p) { if (!seen[p.id]) { seen[p.id] = 1; out.push(p); } }); });
        frozenPool = out.filter(function (p) {
          var t = lower(p.tags);
          return String(p.type || p.product_type || '').toLowerCase() === 'frozen' && t.indexOf('cc_solo_ok') === -1 && t.indexOf('free-gift') === -1;
        });
        return frozenPool;
      });
  }
  function firstAvail(p) { return (p.variants || []).filter(function (v) { return v.available !== false; })[0]; }
  function imgOf(p, w) {
    var img = p.featured_image || (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '';
    if (typeof img === 'object') img = img.src || '';
    if (img.indexOf('//') === 0) img = 'https:' + img;
    return img ? img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : '';
  }
  function pickRows(pool, c, n) {
    var inCart = {}; (c.items || []).forEach(function (li) { inCart[li.product_id] = 1; });
    return pool.filter(function (p) { return !inCart[p.id] && firstAvail(p); }).slice(0, n).map(function (p) {
      var v = firstAvail(p);
      var price = typeof v.price === 'string' ? Math.round(parseFloat(v.price) * 100) : v.price;
      var tags = P.badgeHTML(p.tags);
      return '<div class="lbf-cj-pick"><img src="' + esc(imgOf(p, 120)) + '" alt="" width="48" height="48" loading="lazy">' +
        '<div class="lbf-cj-pick__b"><span class="lbf-cj-pick__n">' + esc(P.shortTitle(p.title)) + '</span>' + (tags ? '<span class="lbf-tray__tags">' + tags + '</span>' : '') +
        '<span class="lbf-cj-pick__p">' + money(price) + '</span></div>' +
        '<button type="button" class="lbf-cj-plus" data-add-frozen="' + v.id + '" data-handle="' + esc(p.handle) + '" aria-label="' + lbnT('cart.pick_add_aria', 'Add {{ name }}', { name: esc(P.shortTitle(p.title)) }) + '">' +
        '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg></button></div>';
    }).join('');
  }
  function renderChoice(m) {
    var slot = document.querySelector('.lbf-cj-choice-slot td');
    var row = document.querySelector('.lbf-cj-choice-slot');
    if (!slot) return;
    if (!m.moqUnmet) { renderChoice.__viewKey = null; row.hidden = true; slot.innerHTML = ''; return; }
    row.hidden = false;
    var need = CORE.MOQ - m.fzQty;
    /* GA4: one view per appearance of this card state (not per cart repaint) */
    var viewKey = m.fzQty + '/' + need + '/' + (m.hasRte ? 1 : 0);
    if (renderChoice.__viewKey !== viewKey) { renderChoice.__viewKey = viewKey; track('lbf_checkout_block_view', { have: m.fzQty, need: need }); }
    var add = need > 1 ? lbnT('cart.choice_add_other', 'Add {{ n }} more frozen dishes', { n: need }) : lbnT('cart.choice_add_one', 'Add {{ n }} more frozen dish', { n: need });
    loadFrozenPool(m.c).then(function (pool) {
      slot = document.querySelector('.lbf-cj-choice-slot td'); if (!slot) return;
      var picks = pickRows(pool, m.c, 3) + '<a class="lbf-cj-all" href="' + ROOT + 'collections/' + FROZEN_COLL + '">' + lbnT('cart.choice_see_all', 'See all frozen dishes') + '</a>';
      if (!m.hasRte) {
        slot.innerHTML = '<div class="lbf-cj-choice" id="lbf-cj-choice"><div class="lbf-cj-opt"><h3>' + lbnT('cart.choice_to_checkout', '{{ add }} to check out', { add: add }) + '</h3>' +
          '<p>' + lbnT('cart.choice_min_note', 'Cold-chain delivery needs at least {{ n }} frozen dishes.', { n: CORE.MOQ }) + '</p>' + picks + '</div></div>';
      } else {
        var free = m.rteTotal >= CORE.TDRY;
        slot.innerHTML = '<div class="lbf-cj-choice" id="lbf-cj-choice"><h3 class="lbf-cj-choice__t">' + lbnT('cart.choice_title', 'How do you want to ship?') + '</h3>' +
          '<div class="lbf-cj-opt"><h4>' + add + '</h4><p>' + lbnT('cart.choice_together', 'Everything ships together by cold chain, in one insulated box.') + '</p>' + picks + '</div>' +
          '<div class="lbf-cj-or" aria-hidden="true"><span>' + lbnT('cart.choice_or', 'OR') + '</span></div>' +
          '<div class="lbf-cj-opt"><h4>' + lbnT('cart.choice_rte_title', 'Check out ready-to-eat only') + '</h4><p>' + (free ? lbnT('cart.choice_rte_free', 'FREE delivery. Your frozen dish comes out of this order.') : lbnT('cart.choice_rte_fee', '{{ fee }} delivery, FREE from {{ threshold }}. Your frozen dish comes out of this order.', { fee: money(CORE.RD), threshold: money(CORE.TDRY).replace('.00', '') })) + '</p>' +
          '<button type="button" class="lbf-cj-outline" data-rte-only>' + lbnT('cart.choice_rte_btn', 'CHECK OUT READY-TO-EAT · {{ amount }}', { amount: money(m.rteTotal) }) + '</button></div></div>';
      }
    });
  }
  function removeFrozen(via) {
    var c = CART.get(); if (!c) return Promise.resolve();
    var updates = {};
    (c.items || []).forEach(function (li) { if (isFrozen(li)) updates[li.key] = 0; });
    if (!Object.keys(updates).length) return Promise.resolve();
    return fetch(ROOT + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: updates }) })
      .then(function () { return CART.load(); })
      .then(function () {
        try { if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'lbf-cart-page' }); } catch (e) {}
        document.dispatchEvent(new CustomEvent('cart:update'));
        LBF_TOAST.show({ kind: 'frozen_removed', tile: 'blue', icon: 'snow', title: lbnT('cart.toast_frozen_removed_title', 'Frozen dish removed'), sub: lbnT('cart.toast_frozen_removed_sub', 'Your ready-to-eat order is ready to check out') });
        if (via) track('lbf_blocked_resolve', { via: via });
      });
  }

  /* ---------------- 4. points bar + "Goes with your cart" carousel (Huel pattern, Carl 2026-09-26) ---------------- */
  var railKey = '', ptsOpen = false;
  function renderRail(m) {
    var pts = document.getElementById('lbf-cj-pts');
    if (pts) {
      var wasOpen = ptsOpen; /* keep it open across re-paints (and Dawn re-draws) only if the shopper opened it */
      pts.innerHTML = (m.c.items || []).length ? CART.pointsHTML(m.c) : '';
      var card = pts.querySelector('.lbf-pts'), hb = pts.querySelector('.lbf-pts__h');
      if (card && wasOpen) { card.classList.add('is-open'); hb.setAttribute('aria-expanded', 'true'); }
      if (hb) hb.addEventListener('click', function () { var o = card.classList.toggle('is-open'); ptsOpen = o; hb.setAttribute('aria-expanded', o ? 'true' : 'false'); });
      Array.prototype.forEach.call(pts.querySelectorAll('[data-pts-cta]'), function (a) { a.addEventListener('click', function () { track('lbf_points_cta', { cta: a.getAttribute('data-pts-cta') }); }); });
    }
    var el = document.getElementById('lbf-cj-rail');
    if (!el) return;
    var hide = !(m.c.items || []).length || m.moqUnmet || m.blocked;
    el.hidden = hide;
    if (hide) return;
    var key = (m.c.items || []).map(function (li) { return li.variant_id + 'x' + li.quantity; }).join(',');
    if (key === railKey && el.__key === key) return; /* a re-drawn (fresh) rail is filled again */
    railKey = key;
    el.classList.add('lbf-xs');
    CART.bindRail(el, 'cart');
    el.__key = key;
    CART.crossSell(m.c).then(function (items) {
      el = document.getElementById('lbf-cj-rail'); if (!el) return;
      el.classList.add('lbf-xs'); CART.bindRail(el, 'cart'); el.__key = key;
      el.innerHTML = CART.railHTML(items);
      el.hidden = !items.length;
    });
  }

  /* ---------------- 5. order note ---------------- */
  function renderNote(m) {
    var el = document.getElementById('lbf-cj-note');
    if (!el || el.__lbf) return;
    el.__lbf = 1;
    var note = m.c.note || '';
    el.innerHTML = '<button type="button" class="lbf-cj-note__btn" aria-expanded="' + (note ? 'true' : 'false') + '" aria-controls="lbf-cj-note-f">' + lbnT('cart.note_title', 'Order special instructions') + '<span aria-hidden="true">+</span></button>' +
      '<div class="lbf-cj-note__f" id="lbf-cj-note-f"' + (note ? '' : ' hidden') + '><label class="visually-hidden" for="lbf-cj-note-t">' + lbnT('cart.note_title', 'Order special instructions') + '</label>' +
      '<textarea id="lbf-cj-note-t" rows="3" maxlength="500" placeholder="' + lbnT('cart.note_placeholder', 'Delivery notes, gift message…') + '">' + esc(note) + '</textarea><span class="lbf-cj-note__s" aria-live="polite"></span></div>';
    var btn = el.querySelector('button'), box = el.querySelector('.lbf-cj-note__f'), ta = el.querySelector('textarea'), st = el.querySelector('.lbf-cj-note__s'), t = 0;
    btn.addEventListener('click', function () { var open = box.hidden; box.hidden = !open; btn.setAttribute('aria-expanded', open ? 'true' : 'false'); if (open) ta.focus(); });
    ta.addEventListener('input', function () {
      clearTimeout(t); st.textContent = '';
      t = setTimeout(function () { CART.setNote(ta.value).then(function () { st.textContent = lbnT('cart.note_saved', 'Saved'); }); }, 600);
    });
  }

  /* ---------------- 6. sticky footer ---------------- */
  function shippingCell(m) {
    var sc = laneCell(m), s = m.s;
    if (sc.fee && s.voucherNote) { sc.struck = money(s.feeBase); sc.fee = s.feeAfter ? money(s.feeAfter) : lbnT('ship.free_caps', 'FREE'); sc.free = !s.feeAfter; }
    return sc;
  }
  function laneCell(m) {
    var s = m.s;
    if (s.split && s.split.quotable) return { chip: chipLabel(m.region), fee: s.split.total === 0 ? lbnT('ship.free_caps', 'FREE') : money(s.split.total), free: s.split.total === 0, note: lbnT('cart.footer_two_boxes', '2 boxes') };
    if (s.kind === 'pickstate') return { chip: lbnT('ship.chip_choose_area', 'Choose area'), fee: '', pick: true };
    if (s.kind === 'progress') return { chip: lbnT('ship.chip_west_msia', 'West Msia'), fee: money(s.rate) };
    if (s.kind === 'free') return { chip: lbnT('ship.chip_west_msia', 'West Msia'), fee: lbnT('ship.free_caps', 'FREE'), struck: money(s.saved || CORE.RD), free: true };
    if (s.kind === 'mixed-progress') return { chip: chipLabel(s.state), fee: money(s.rate) };
    if (s.kind === 'mixed-floor') return s.rate === 0
      ? { chip: chipLabel(s.state), fee: lbnT('ship.free_caps', 'FREE'), struck: money(s.baseRate), free: true }
      : { chip: chipLabel(s.state), fee: money(s.floorRate), struck: money(s.baseRate) };
    if (s.kind === 'eastmsia') return { chip: lbnT('ship.chip_east_msia', 'East Msia'), fee: lbnT('ship.from_amount', 'From {{ amount }}', { amount: money(CORE.EAST_FROM) }) };
    return { chip: chipLabel(m.region), fee: '' };
  }
  var CARET = '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';
  var LOCK = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>';
  /* Other checkout blockers register here (lbn-delivery-week.js: no delivery week picked). Each returns null or
     { id, text, focus }; the footer shows every reason above one locked button. Announce changes with the
     'lbf:checkout-guard-change' event. A guard that throws counts as no blocker (fail open). */
  function guardReasons() {
    return (window.LBF_CHECKOUT_GUARDS || []).map(function (g) { try { return g(); } catch (e) { return null; } }).filter(Boolean);
  }
  function renderFooter(m) {
    var f, c = m.c, extra = guardReasons();
    if (DRAWER) {
      /* drawer: the footer lives in the drawer's own footer slot (server-rendered there, re-rendered with it) */
      var slot = document.getElementById('lbf-cj-drawer-foot'); if (!slot) return;
      f = slot.querySelector('.lbf-cj-footer');
      if (!f) { f = document.createElement('div'); f.className = 'lbf-cj-footer lbf-cj-footer--drawer'; slot.appendChild(f); }
      if (!f.__lbf) { f.__lbf = 1; bindFooter(f); }
      if (!(c.items || []).length) { f.hidden = true; return; }
      f.hidden = false;
    } else {
    f = document.querySelector('.lbf-cj-footer');
    if (!f) { f = document.createElement('div'); f.className = 'lbf-cj-footer'; document.body.appendChild(f); }
    if (!f.__lbf) { f.__lbf = 1; bindFooter(f); }
    /* a fixed bar must hang off <body>: any section around it with content-visibility / contain / transform becomes its frame */
    if (f.parentElement !== document.body) document.body.appendChild(f);
    if (!(c.items || []).length) { f.hidden = true; document.documentElement.classList.remove('lbf-cj-foot-on'); return; }
    f.hidden = false; document.documentElement.classList.add('lbf-cj-foot-on');
    }
    var sub = '<div class="lbf-cj-f__row"><span>' + lbnT('cart.footer_subtotal', 'Subtotal') + ' <em>(' + (c.item_count > 1 ? lbnT('cart.footer_items_other', '{{ n }} items', { n: c.item_count }) : lbnT('cart.footer_items_one', '{{ n }} item', { n: c.item_count })) + ')</em></span><span class="lbf-cj-f__v">' +
      /* struck at the "You saved RMx on this order" baseline (markdown and order discount), so struck - total = that saving */
      (m.srp > c.total_price ? '<s>' + money(m.srp) + '</s>' : '') + money(c.total_price) + '</span></div>';
    var html;
    if (m.blocked) {
      html = sub + '<p class="lbf-cj-f__red">' + lbnT('ship.blocked_there', 'We can\'t ship the frozen dishes in your cart there.') + '</p>' +
        '<div class="lbf-cj-f__two"><button type="button" class="lbf-cj-outline" data-f="remove">' + lbnT('cart.footer_remove_frozen', 'REMOVE FROZEN DISHES') + '</button><button type="button" class="lbf-cj-yel" data-f="area">' + lbnT('cart.footer_change_location', 'CHANGE LOCATION') + '</button></div>';
    } else if (m.moqUnmet) {
      var need = CORE.MOQ - m.fzQty;
      html = sub + redLines(extra) + '<button type="button" class="lbf-cj-yel" data-f="choice">' + (m.hasRte ? lbnT('cart.footer_choose_ship', 'CHOOSE HOW TO SHIP') : (need > 1 ? lbnT('cart.footer_add_frozen_other', 'ADD {{ n }} MORE FROZEN DISHES', { n: need }) : lbnT('cart.footer_add_frozen_one', 'ADD {{ n }} MORE FROZEN DISH', { n: need }))) + '</button>';
    } else {
      var sc = shippingCell(m);
      html = sub + '<div class="lbf-cj-f__row"><span>' + lbnT('cart.footer_shipping', 'Shipping') + ' <button type="button" class="lbf-cj-chip' + (sc.pick ? ' is-pick' : '') + '" data-f="area">' + esc(sc.chip) + ' ' + CARET + '</button></span>' +
        '<span class="lbf-cj-f__v' + (sc.free ? ' is-free' : '') + '">' + (sc.struck ? '<s>' + sc.struck + '</s>' : '') + esc(sc.fee) + (sc.note ? ' <em>' + sc.note + '</em>' : '') + '</span></div>' +
        (extra.length ? redLines(extra) + '<button type="button" class="lbf-cj-yel lbf-cj-go is-locked" aria-disabled="true" data-f="guard">' :
        DRAWER ? '<button type="submit" id="CartDrawer-Checkout" name="checkout" form="CartDrawer-Form" class="lbf-cj-yel lbf-cj-go" data-f="checkout">' : '<button type="button" class="lbf-cj-yel lbf-cj-go" data-f="checkout">') + LOCK + lbnT('cart.footer_checkout', 'CHECKOUT SECURELY') + '</button>';
    }
    f.innerHTML = '<div class="lbf-cj-f__in">' + html + '</div>';
  }
  function redLines(reasons) {
    return reasons.map(function (r) { return '<p class="lbf-cj-f__red" data-guard="' + esc(r.id) + '">' + esc(r.text) + '</p>'; }).join('');
  }
  function bindFooter(f) {
    f.addEventListener('click', function (e) {
      var b = e.target.closest('[data-f]'); if (!b) return;
      var a = b.getAttribute('data-f');
      if (a === 'area') openArea(1);
      else if (a === 'remove') removeFrozen('removed_frozen');
      else if (a === 'choice') {
        /* 23 Oct (Carl D3): with CNY dishes in the cart every tap opens the two-box sheet; otherwise the choice card */
        if (window.LBN_TWO_BOX && window.LBN_TWO_BOX.applies()) { window.LBN_TWO_BOX.open('locked'); return; }
        var card = document.getElementById('lbf-cj-choice'); if (card) card.scrollIntoView({ block: 'center' });
      }
      else if (a === 'guard') {
        var r = guardReasons()[0];
        if (r && r.focus) r.focus();
      }
      else if (a === 'checkout') {
        track('lbf_checkout_click', { surface: DRAWER ? 'cart-drawer' : 'cart-footer' });
        if (DRAWER) return; /* the drawer's own button is the real submit (form=CartDrawer-Form) */
        e.preventDefault();
        var n = document.querySelector('#checkout, button[name="checkout"]');
        if (n && !n.disabled) n.click(); else window.location.href = ROOT + 'checkout';
      }
    });
  }

  /* ---------------- clicks inside the page ---------------- */
  document.addEventListener('click', function (e) {
    var fz = e.target.closest('[data-add-frozen]');
    if (fz) {
      e.preventDefault(); CART.flash(fz); fz.disabled = true;
      track('lbf_moq_choice', { choice: 'add', pick: fz.getAttribute('data-handle') });
      CART.addItems([{ id: fz.getAttribute('data-add-frozen'), quantity: 1 }]);
      return;
    }
    if (e.target.closest('[data-rte-only]')) {
      e.preventDefault(); track('lbf_moq_choice', { choice: 'rte_only' }); removeFrozen('rte_only'); return;
    }
  });
  document.addEventListener('lbf:shipping-state-change', function () { var c = CART.get(); if (c) paint(c); });
  document.addEventListener('lbf:checkout-guard-change', function () { var c = CART.get(); if (c) paint(c); });
  document.addEventListener('lbf:drawer-refreshed', function () {
    window.LBF_CART_LAST_PAINT_KEY = '';
    var c = CART.get(); if (c) paint(c);
  });

  function cartPaintKey(c) {
    if (!c) return '';
    return [c.item_count || 0, c.total_price || 0, (c.items || []).map(function (item) {
      return String(item.key || item.variant_id || '') + ':' + String(item.quantity || 0);
    }).join('|'), (c.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; }).sort().join(',')].join('::');
  }
  var paintT = 0, dirty = false, paintRevision = 0;
  function paint(c) {
    var revision = ++paintRevision;
    // Prepare totals/shipping while closed; defer only the recommendation rail.
    if (DRAWER && !drawerOpen()) dirty = true;
    clearTimeout(paintT);
    paintT = setTimeout(function () {
      withInfo(c).then(function (c2) {
        if (revision !== paintRevision || cartPaintKey(c2) !== cartPaintKey(CART.get())) return;
        var m = model(c2);
        renderSummary(m); renderLineDeals(m); renderGroups(m); renderChoice(m);
        if (!DRAWER || drawerOpen()) renderRail(m);
        renderNote(m); renderFooter(m);
        window.LBF_CART_LAST_PAINT_KEY = cartPaintKey(c2);
        try { document.dispatchEvent(new CustomEvent('lbf:cart-painted', { detail: { key: window.LBF_CART_LAST_PAINT_KEY } })); } catch (e) {}
        if (!DRAWER) document.documentElement.classList.add('lbf-cj-cart');
      });
    }, 30);
  }
  CART.on(paint);
  /* Dawn (and cart-recommendations.js) re-draw the WHOLE <cart-items> innerHTML after a change - summary, rail and
     #main-cart-items included. Watch <cart-items> itself, which is never replaced: watching #main-cart-items went
     deaf after the first re-draw, and a big cart (slow re-draw, landing after our paint) was left grey (Carl's video). */
  var items = document.querySelector('cart-items') || DRAWER_EL || document.body;
  /* drawer: paint when it opens (the cart may have changed while it was closed) */
  if (DRAWER) new MutationObserver(function () { if (drawerOpen() && dirty) { dirty = false; var c = CART.get(); if (c) paint(c); } }).observe(DRAWER_EL, { attributes: true, attributeFilter: ['class'] });
  if (items) new MutationObserver(function () {
    var c = CART.get(); if (!c) return;
    var fz = document.querySelector('.lbf-cart-sec--frozen .lbf-cart-sec__title');
    var sum = document.getElementById('lbf-cj-summary'), rail = document.getElementById('lbf-cj-rail');
    var fresh = (fz && !fz.__lbf) || (sum && !sum.__seen) || (rail && !rail.__seen);
    if (sum) sum.__seen = 1; if (rail) rail.__seen = 1;
    if (fresh) paint(c);
  }).observe(items, { childList: true, subtree: true });
})();
